import { gate } from 'hub-http/gates';
// v3 gates - https://product.hubteam.com/docs/gating/next-gen/usage.html#frontend-usage

export const TRI_TEMPORARY_DISCOUNT = gate('TRI::TemporaryDiscount');
export const HUBSPOT_CREDITS_PAGE_REDIRECT = gate('PPFE:HubspotCreditsPageRedirect');
export const EMEA_HSFM_PROMO_BANNER = gate('HSfMAprilPromoBannerEMEA1');
export const EMEA_HSFM_PROMO_BANNER_OVERFLOW = gate('HSfMAprilPromoBannerEMEA2');
export const PPIA_SALESBOT = gate('PPIA:SalesBot');
export const NAM_HSFM_PROMO_BANNER = gate('HSfMAprilPromoBannerNAM1');
export const NAM_HSFM_PROMO_BANNER_OVERFLOW = gate('HSfMAprilPromoBannerNAM2');